import { SITE_BASE_URL } from './site';

/**
 * Content ids are uppercase-underscore enums (e.g. `BHASTRIKA`, `QUIET_FURNACE`);
 * public web URLs use lowercase-hyphen slugs (e.g. `bhastrika`, `quiet-furnace`).
 * These two functions are inverses and are the single source of truth for that
 * mapping — web routing, the OG card generator, and mobile share links all derive
 * the same slug, so a shared link resolves and unfurls identically everywhere.
 */
export function idToSlug(id: string): string {
  return id.toLowerCase().replace(/_/g, '-');
}

export function slugToId(slug: string): string {
  return slug.toUpperCase().replace(/-/g, '_');
}

/** Shareable web URL for a breathwork detail page (Universal-Link claimed path). */
export function breathworkWebUrl(id: string): string {
  return `${SITE_BASE_URL}/breathworks/${idToSlug(id)}`;
}

/** Shareable web URL for a journey detail page (Universal-Link claimed path). */
export function journeyWebUrl(id: string): string {
  return `${SITE_BASE_URL}/journeys/${idToSlug(id)}`;
}
